/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WelcomeImport } from './routes/welcome'
import { Route as ForbiddenImport } from './routes/forbidden'
import { Route as CliLoginImport } from './routes/cli-login'
import { Route as SplatImport } from './routes/$'
import { Route as IndexImport } from './routes/index'
import { Route as WorkspacesIndexImport } from './routes/workspaces/index'
import { Route as WorkspacesWorkspaceIdImport } from './routes/workspaces/$workspaceId'
import { Route as OauthInterstitialImport } from './routes/oauth/interstitial'
import { Route as WorkspacesWorkspaceIdIndexImport } from './routes/workspaces/$workspaceId/index'
import { Route as WorkspacesWorkspaceIdUsageImport } from './routes/workspaces/$workspaceId/usage'
import { Route as WorkspacesWorkspaceIdSettingsImport } from './routes/workspaces/$workspaceId/settings'
import { Route as WorkspacesWorkspaceIdProfileImport } from './routes/workspaces/$workspaceId/profile'
import { Route as WorkspacesWorkspaceIdHomeImport } from './routes/workspaces/$workspaceId/home'
import { Route as WorkspacesWorkspaceIdCreateBotImport } from './routes/workspaces/$workspaceId/create-bot'
import { Route as WorkspacesWorkspaceIdChatbotsImport } from './routes/workspaces/$workspaceId/chatbots_'
import { Route as WorkspacesWorkspaceIdBotsImport } from './routes/workspaces/$workspaceId/bots_'
import { Route as WorkspacesWorkspaceIdBillingImport } from './routes/workspaces/$workspaceId/billing'
import { Route as WorkspacesWorkspaceIdSplatImport } from './routes/workspaces/$workspaceId/$'
import { Route as WorkspacesWorkspaceIdUsageIndexImport } from './routes/workspaces/$workspaceId/usage/index'
import { Route as WorkspacesWorkspaceIdSettingsIndexImport } from './routes/workspaces/$workspaceId/settings/index'
import { Route as WorkspacesWorkspaceIdIntegrationsIndexImport } from './routes/workspaces/$workspaceId/integrations/index'
import { Route as WorkspacesWorkspaceIdBillingIndexImport } from './routes/workspaces/$workspaceId/billing/index'
import { Route as WorkspacesWorkspaceIdUsageMonthlySummaryImport } from './routes/workspaces/$workspaceId/usage/monthly-summary'
import { Route as WorkspacesWorkspaceIdUsageAiSpendImport } from './routes/workspaces/$workspaceId/usage/ai-spend'
import { Route as WorkspacesWorkspaceIdSettingsMembersImport } from './routes/workspaces/$workspaceId/settings/members'
import { Route as WorkspacesWorkspaceIdSettingsDetailsImport } from './routes/workspaces/$workspaceId/settings/details'
import { Route as WorkspacesWorkspaceIdSettingsAuditsImport } from './routes/workspaces/$workspaceId/settings/audits'
import { Route as WorkspacesWorkspaceIdSettingsSplatImport } from './routes/workspaces/$workspaceId/settings/$'
import { Route as WorkspacesWorkspaceIdProfileSettingsImport } from './routes/workspaces/$workspaceId/profile/settings'
import { Route as WorkspacesWorkspaceIdProfileAccountImport } from './routes/workspaces/$workspaceId/profile/account'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdImport } from './routes/workspaces/$workspaceId/integrations/$integrationId'
import { Route as WorkspacesWorkspaceIdChatbotsBotIdImport } from './routes/workspaces/$workspaceId/chatbots/$botId'
import { Route as WorkspacesWorkspaceIdBotsBotIdImport } from './routes/workspaces/$workspaceId/bots/$botId'
import { Route as WorkspacesWorkspaceIdBillingSummaryImport } from './routes/workspaces/$workspaceId/billing/summary'
import { Route as WorkspacesWorkspaceIdBillingPlansImport } from './routes/workspaces/$workspaceId/billing/plans'
import { Route as WorkspacesWorkspaceIdBillingAddOnsImport } from './routes/workspaces/$workspaceId/billing/add-ons'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/index'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/versions'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/settings'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/logs'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/$'
import { Route as WorkspacesWorkspaceIdChatbotsBotIdSplatImport } from './routes/workspaces/$workspaceId/chatbots/$botId/$'
import { Route as WorkspacesWorkspaceIdBotsBotIdWorkflowsImport } from './routes/workspaces/$workspaceId/bots/$botId/workflows'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat'
import { Route as WorkspacesWorkspaceIdBotsBotIdUsersImport } from './routes/workspaces/$workspaceId/bots/$botId/users'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsImport } from './routes/workspaces/$workspaceId/bots/$botId/settings'
import { Route as WorkspacesWorkspaceIdBotsBotIdOverviewImport } from './routes/workspaces/$workspaceId/bots/$botId/overview'
import { Route as WorkspacesWorkspaceIdBotsBotIdNewChatImport } from './routes/workspaces/$workspaceId/bots/$botId/new-chat'
import { Route as WorkspacesWorkspaceIdBotsBotIdNewBotImport } from './routes/workspaces/$workspaceId/bots/$botId/new-bot'
import { Route as WorkspacesWorkspaceIdBotsBotIdLogsImport } from './routes/workspaces/$workspaceId/bots/$botId/logs'
import { Route as WorkspacesWorkspaceIdBotsBotIdHitlImport } from './routes/workspaces/$workspaceId/bots/$botId/hitl'
import { Route as WorkspacesWorkspaceIdBotsBotIdFilesImport } from './routes/workspaces/$workspaceId/bots/$botId/files'
import { Route as WorkspacesWorkspaceIdBotsBotIdEventsImport } from './routes/workspaces/$workspaceId/bots/$botId/events'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations'
import { Route as WorkspacesWorkspaceIdBotsBotIdAnalyticsImport } from './routes/workspaces/$workspaceId/bots/$botId/analytics'
import { Route as WorkspacesWorkspaceIdBotsBotIdSplatImport } from './routes/workspaces/$workspaceId/bots/$botId/$'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdTablesIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/tables/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/settings/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/knowledge-bases/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdIssuesIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/issues/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdTablesTableIdImport } from './routes/workspaces/$workspaceId/bots/$botId/tables/$tableId'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsGeneralImport } from './routes/workspaces/$workspaceId/bots/$botId/settings/general'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlImport } from './routes/workspaces/$workspaceId/bots/$botId/settings/access-control'
import { Route as WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdImport } from './routes/workspaces/$workspaceId/bots/$botId/issues/$issueId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdImport } from './routes/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
import { Route as WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/theme'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
import { Route as WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdImport } from './routes/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'

// Create/Update Routes

const WelcomeRoute = WelcomeImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRoute,
} as any)

const ForbiddenRoute = ForbiddenImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRoute,
} as any)

const CliLoginRoute = CliLoginImport.update({
  id: '/cli-login',
  path: '/cli-login',
  getParentRoute: () => rootRoute,
} as any)

const SplatRoute = SplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const WorkspacesIndexRoute = WorkspacesIndexImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => rootRoute,
} as any)

const WorkspacesWorkspaceIdRoute = WorkspacesWorkspaceIdImport.update({
  id: '/workspaces/$workspaceId',
  path: '/workspaces/$workspaceId',
  getParentRoute: () => rootRoute,
} as any)

const OauthInterstitialRoute = OauthInterstitialImport.update({
  id: '/oauth/interstitial',
  path: '/oauth/interstitial',
  getParentRoute: () => rootRoute,
} as any)

const WorkspacesWorkspaceIdIndexRoute = WorkspacesWorkspaceIdIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any,
)

const WorkspacesWorkspaceIdUsageRoute = WorkspacesWorkspaceIdUsageImport.update(
  {
    id: '/usage',
    path: '/usage',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any,
)

const WorkspacesWorkspaceIdSettingsRoute =
  WorkspacesWorkspaceIdSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdProfileRoute =
  WorkspacesWorkspaceIdProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdHomeRoute = WorkspacesWorkspaceIdHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => WorkspacesWorkspaceIdRoute,
} as any)

const WorkspacesWorkspaceIdCreateBotRoute =
  WorkspacesWorkspaceIdCreateBotImport.update({
    id: '/create-bot',
    path: '/create-bot',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdChatbotsRoute =
  WorkspacesWorkspaceIdChatbotsImport.update({
    id: '/chatbots_',
    path: '/chatbots',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsRoute = WorkspacesWorkspaceIdBotsImport.update({
  id: '/bots_',
  path: '/bots',
  getParentRoute: () => WorkspacesWorkspaceIdRoute,
} as any)

const WorkspacesWorkspaceIdBillingRoute =
  WorkspacesWorkspaceIdBillingImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdSplatRoute = WorkspacesWorkspaceIdSplatImport.update(
  {
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any,
)

const WorkspacesWorkspaceIdUsageIndexRoute =
  WorkspacesWorkspaceIdUsageIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdUsageRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsIndexRoute =
  WorkspacesWorkspaceIdSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIndexImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdBillingIndexRoute =
  WorkspacesWorkspaceIdBillingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBillingRoute,
  } as any)

const WorkspacesWorkspaceIdUsageMonthlySummaryRoute =
  WorkspacesWorkspaceIdUsageMonthlySummaryImport.update({
    id: '/monthly-summary',
    path: '/monthly-summary',
    getParentRoute: () => WorkspacesWorkspaceIdUsageRoute,
  } as any)

const WorkspacesWorkspaceIdUsageAiSpendRoute =
  WorkspacesWorkspaceIdUsageAiSpendImport.update({
    id: '/ai-spend',
    path: '/ai-spend',
    getParentRoute: () => WorkspacesWorkspaceIdUsageRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsMembersRoute =
  WorkspacesWorkspaceIdSettingsMembersImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsDetailsRoute =
  WorkspacesWorkspaceIdSettingsDetailsImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsAuditsRoute =
  WorkspacesWorkspaceIdSettingsAuditsImport.update({
    id: '/audits',
    path: '/audits',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsSplatRoute =
  WorkspacesWorkspaceIdSettingsSplatImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdProfileSettingsRoute =
  WorkspacesWorkspaceIdProfileSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdProfileRoute,
  } as any)

const WorkspacesWorkspaceIdProfileAccountRoute =
  WorkspacesWorkspaceIdProfileAccountImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => WorkspacesWorkspaceIdProfileRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdChatbotsBotIdRoute =
  WorkspacesWorkspaceIdChatbotsBotIdImport.update({
    id: '/chatbots/$botId',
    path: '/chatbots/$botId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdRoute =
  WorkspacesWorkspaceIdBotsBotIdImport.update({
    id: '/bots/$botId',
    path: '/bots/$botId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdBillingSummaryRoute =
  WorkspacesWorkspaceIdBillingSummaryImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => WorkspacesWorkspaceIdBillingRoute,
  } as any)

const WorkspacesWorkspaceIdBillingPlansRoute =
  WorkspacesWorkspaceIdBillingPlansImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => WorkspacesWorkspaceIdBillingRoute,
  } as any)

const WorkspacesWorkspaceIdBillingAddOnsRoute =
  WorkspacesWorkspaceIdBillingAddOnsImport.update({
    id: '/add-ons',
    path: '/add-ons',
    getParentRoute: () => WorkspacesWorkspaceIdBillingRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdChatbotsBotIdSplatRoute =
  WorkspacesWorkspaceIdChatbotsBotIdSplatImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdChatbotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute =
  WorkspacesWorkspaceIdBotsBotIdWorkflowsImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatImport.update({
    id: '/webchat',
    path: '/webchat',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdUsersRoute =
  WorkspacesWorkspaceIdBotsBotIdUsersImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdSettingsRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdOverviewRoute =
  WorkspacesWorkspaceIdBotsBotIdOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdNewChatRoute =
  WorkspacesWorkspaceIdBotsBotIdNewChatImport.update({
    id: '/new-chat',
    path: '/new-chat',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdNewBotRoute =
  WorkspacesWorkspaceIdBotsBotIdNewBotImport.update({
    id: '/new-bot',
    path: '/new-bot',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdLogsRoute =
  WorkspacesWorkspaceIdBotsBotIdLogsImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdHitlRoute =
  WorkspacesWorkspaceIdBotsBotIdHitlImport.update({
    id: '/hitl',
    path: '/hitl',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdFilesRoute =
  WorkspacesWorkspaceIdBotsBotIdFilesImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdEventsRoute =
  WorkspacesWorkspaceIdBotsBotIdEventsImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationsRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute =
  WorkspacesWorkspaceIdBotsBotIdAnalyticsImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdSplatRoute =
  WorkspacesWorkspaceIdBotsBotIdSplatImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdTablesIndexImport.update({
    id: '/tables/',
    path: '/tables/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexImport.update({
    id: '/knowledge-bases/',
    path: '/knowledge-bases/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdIssuesIndexImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute =
  WorkspacesWorkspaceIdBotsBotIdTablesTableIdImport.update({
    id: '/tables/$tableId',
    path: '/tables/$tableId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsGeneralImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlImport.update({
    id: '/access-control',
    path: '/access-control',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute =
  WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdImport.update({
    id: '/issues/$issueId',
    path: '/issues/$issueId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdConversationsRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdImport.update({
    id: '/conversationIdQuery/$messageId',
    path: '/conversationIdQuery/$messageId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexImport.update({
    id: '/knowledge-bases/$kbId/',
    path: '/knowledge-bases/$kbId/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeImport.update({
    id: '/v2/theme',
    path: '/v2/theme',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareImport.update({
    id: '/v2/share',
    path: '/v2/share',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralImport.update({
    id: '/v2/general',
    path: '/v2/general',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsImport.update({
    id: '/v2/advanced-settings',
    path: '/v2/advanced-settings',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute =
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdImport.update({
    id: '/knowledge-bases/$kbId/$dsId',
    path: '/knowledge-bases/$kbId/$dsId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdImport.update(
    {
      id: '/messages/$messageId',
      path: '/messages/$messageId',
      getParentRoute: () =>
        WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatImport
      parentRoute: typeof rootRoute
    }
    '/cli-login': {
      id: '/cli-login'
      path: '/cli-login'
      fullPath: '/cli-login'
      preLoaderRoute: typeof CliLoginImport
      parentRoute: typeof rootRoute
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenImport
      parentRoute: typeof rootRoute
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeImport
      parentRoute: typeof rootRoute
    }
    '/oauth/interstitial': {
      id: '/oauth/interstitial'
      path: '/oauth/interstitial'
      fullPath: '/oauth/interstitial'
      preLoaderRoute: typeof OauthInterstitialImport
      parentRoute: typeof rootRoute
    }
    '/workspaces/$workspaceId': {
      id: '/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdImport
      parentRoute: typeof rootRoute
    }
    '/workspaces/': {
      id: '/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WorkspacesIndexImport
      parentRoute: typeof rootRoute
    }
    '/workspaces/$workspaceId/$': {
      id: '/workspaces/$workspaceId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/billing': {
      id: '/workspaces/$workspaceId/billing'
      path: '/billing'
      fullPath: '/workspaces/$workspaceId/billing'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBillingImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/bots_': {
      id: '/workspaces/$workspaceId/bots_'
      path: '/bots'
      fullPath: '/workspaces/$workspaceId/bots'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/chatbots_': {
      id: '/workspaces/$workspaceId/chatbots_'
      path: '/chatbots'
      fullPath: '/workspaces/$workspaceId/chatbots'
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/create-bot': {
      id: '/workspaces/$workspaceId/create-bot'
      path: '/create-bot'
      fullPath: '/workspaces/$workspaceId/create-bot'
      preLoaderRoute: typeof WorkspacesWorkspaceIdCreateBotImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/home': {
      id: '/workspaces/$workspaceId/home'
      path: '/home'
      fullPath: '/workspaces/$workspaceId/home'
      preLoaderRoute: typeof WorkspacesWorkspaceIdHomeImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/profile': {
      id: '/workspaces/$workspaceId/profile'
      path: '/profile'
      fullPath: '/workspaces/$workspaceId/profile'
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/settings': {
      id: '/workspaces/$workspaceId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/usage': {
      id: '/workspaces/$workspaceId/usage'
      path: '/usage'
      fullPath: '/workspaces/$workspaceId/usage'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/': {
      id: '/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/billing/add-ons': {
      id: '/workspaces/$workspaceId/billing/add-ons'
      path: '/add-ons'
      fullPath: '/workspaces/$workspaceId/billing/add-ons'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBillingAddOnsImport
      parentRoute: typeof WorkspacesWorkspaceIdBillingImport
    }
    '/workspaces/$workspaceId/billing/plans': {
      id: '/workspaces/$workspaceId/billing/plans'
      path: '/plans'
      fullPath: '/workspaces/$workspaceId/billing/plans'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBillingPlansImport
      parentRoute: typeof WorkspacesWorkspaceIdBillingImport
    }
    '/workspaces/$workspaceId/billing/summary': {
      id: '/workspaces/$workspaceId/billing/summary'
      path: '/summary'
      fullPath: '/workspaces/$workspaceId/billing/summary'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBillingSummaryImport
      parentRoute: typeof WorkspacesWorkspaceIdBillingImport
    }
    '/workspaces/$workspaceId/bots/$botId': {
      id: '/workspaces/$workspaceId/bots/$botId'
      path: '/bots/$botId'
      fullPath: '/workspaces/$workspaceId/bots/$botId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/chatbots/$botId': {
      id: '/workspaces/$workspaceId/chatbots/$botId'
      path: '/chatbots/$botId'
      fullPath: '/workspaces/$workspaceId/chatbots/$botId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId': {
      id: '/workspaces/$workspaceId/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/profile/account': {
      id: '/workspaces/$workspaceId/profile/account'
      path: '/account'
      fullPath: '/workspaces/$workspaceId/profile/account'
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileAccountImport
      parentRoute: typeof WorkspacesWorkspaceIdProfileImport
    }
    '/workspaces/$workspaceId/profile/settings': {
      id: '/workspaces/$workspaceId/profile/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/profile/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdProfileImport
    }
    '/workspaces/$workspaceId/settings/$': {
      id: '/workspaces/$workspaceId/settings/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/settings/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/settings/audits': {
      id: '/workspaces/$workspaceId/settings/audits'
      path: '/audits'
      fullPath: '/workspaces/$workspaceId/settings/audits'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsAuditsImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/settings/details': {
      id: '/workspaces/$workspaceId/settings/details'
      path: '/details'
      fullPath: '/workspaces/$workspaceId/settings/details'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsDetailsImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/settings/members': {
      id: '/workspaces/$workspaceId/settings/members'
      path: '/members'
      fullPath: '/workspaces/$workspaceId/settings/members'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsMembersImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/usage/ai-spend': {
      id: '/workspaces/$workspaceId/usage/ai-spend'
      path: '/ai-spend'
      fullPath: '/workspaces/$workspaceId/usage/ai-spend'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageAiSpendImport
      parentRoute: typeof WorkspacesWorkspaceIdUsageImport
    }
    '/workspaces/$workspaceId/usage/monthly-summary': {
      id: '/workspaces/$workspaceId/usage/monthly-summary'
      path: '/monthly-summary'
      fullPath: '/workspaces/$workspaceId/usage/monthly-summary'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageMonthlySummaryImport
      parentRoute: typeof WorkspacesWorkspaceIdUsageImport
    }
    '/workspaces/$workspaceId/billing/': {
      id: '/workspaces/$workspaceId/billing/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/billing/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBillingIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBillingImport
    }
    '/workspaces/$workspaceId/integrations/': {
      id: '/workspaces/$workspaceId/integrations/'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/integrations'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/settings/': {
      id: '/workspaces/$workspaceId/settings/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/settings/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/usage/': {
      id: '/workspaces/$workspaceId/usage/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/usage/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdUsageImport
    }
    '/workspaces/$workspaceId/bots/$botId/$': {
      id: '/workspaces/$workspaceId/bots/$botId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/bots/$botId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/analytics': {
      id: '/workspaces/$workspaceId/bots/$botId/analytics'
      path: '/analytics'
      fullPath: '/workspaces/$workspaceId/bots/$botId/analytics'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversations': {
      id: '/workspaces/$workspaceId/bots/$botId/conversations'
      path: '/conversations'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversations'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/events': {
      id: '/workspaces/$workspaceId/bots/$botId/events'
      path: '/events'
      fullPath: '/workspaces/$workspaceId/bots/$botId/events'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdEventsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/files': {
      id: '/workspaces/$workspaceId/bots/$botId/files'
      path: '/files'
      fullPath: '/workspaces/$workspaceId/bots/$botId/files'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdFilesImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/hitl': {
      id: '/workspaces/$workspaceId/bots/$botId/hitl'
      path: '/hitl'
      fullPath: '/workspaces/$workspaceId/bots/$botId/hitl'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdHitlImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/logs': {
      id: '/workspaces/$workspaceId/bots/$botId/logs'
      path: '/logs'
      fullPath: '/workspaces/$workspaceId/bots/$botId/logs'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdLogsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/new-bot': {
      id: '/workspaces/$workspaceId/bots/$botId/new-bot'
      path: '/new-bot'
      fullPath: '/workspaces/$workspaceId/bots/$botId/new-bot'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewBotImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/new-chat': {
      id: '/workspaces/$workspaceId/bots/$botId/new-chat'
      path: '/new-chat'
      fullPath: '/workspaces/$workspaceId/bots/$botId/new-chat'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewChatImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/overview': {
      id: '/workspaces/$workspaceId/bots/$botId/overview'
      path: '/overview'
      fullPath: '/workspaces/$workspaceId/bots/$botId/overview'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdOverviewImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/settings': {
      id: '/workspaces/$workspaceId/bots/$botId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/users': {
      id: '/workspaces/$workspaceId/bots/$botId/users'
      path: '/users'
      fullPath: '/workspaces/$workspaceId/bots/$botId/users'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdUsersImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat'
      path: '/webchat'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/workflows': {
      id: '/workspaces/$workspaceId/bots/$botId/workflows'
      path: '/workflows'
      fullPath: '/workspaces/$workspaceId/bots/$botId/workflows'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/chatbots/$botId/$': {
      id: '/workspaces/$workspaceId/chatbots/$botId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/chatbots/$botId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/$': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/logs': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/logs'
      path: '/logs'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/logs'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/settings': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/versions': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/versions'
      path: '/versions'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/versions'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/': {
      id: '/workspaces/$workspaceId/bots/$botId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/bots/$botId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': {
      id: '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
      path: '/conversationIdQuery/$messageId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': {
      id: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsImport
    }
    '/workspaces/$workspaceId/bots/$botId/issues/$issueId': {
      id: '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/settings/access-control': {
      id: '/workspaces/$workspaceId/bots/$botId/settings/access-control'
      path: '/access-control'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings/access-control'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsImport
    }
    '/workspaces/$workspaceId/bots/$botId/settings/general': {
      id: '/workspaces/$workspaceId/bots/$botId/settings/general'
      path: '/general'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings/general'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsImport
    }
    '/workspaces/$workspaceId/bots/$botId/tables/$tableId': {
      id: '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
      path: '/tables/$tableId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/issues/': {
      id: '/workspaces/$workspaceId/bots/$botId/issues/'
      path: '/issues'
      fullPath: '/workspaces/$workspaceId/bots/$botId/issues'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/knowledge-bases/': {
      id: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/'
      path: '/knowledge-bases'
      fullPath: '/workspaces/$workspaceId/bots/$botId/knowledge-bases'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/settings/': {
      id: '/workspaces/$workspaceId/bots/$botId/settings/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsImport
    }
    '/workspaces/$workspaceId/bots/$botId/tables/': {
      id: '/workspaces/$workspaceId/bots/$botId/tables/'
      path: '/tables'
      fullPath: '/workspaces/$workspaceId/bots/$botId/tables'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': {
      id: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
      path: '/knowledge-bases/$kbId/$dsId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
      path: '/v2/advanced-settings'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
      path: '/v2/general'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
      path: '/v2/share'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme'
      path: '/v2/theme'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/': {
      id: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/'
      path: '/knowledge-bases/$kbId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': {
      id: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
      path: '/messages/$messageId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport
    }
  }
}

// Create and export the route tree

interface WorkspacesWorkspaceIdBillingRouteChildren {
  WorkspacesWorkspaceIdBillingAddOnsRoute: typeof WorkspacesWorkspaceIdBillingAddOnsRoute
  WorkspacesWorkspaceIdBillingPlansRoute: typeof WorkspacesWorkspaceIdBillingPlansRoute
  WorkspacesWorkspaceIdBillingSummaryRoute: typeof WorkspacesWorkspaceIdBillingSummaryRoute
  WorkspacesWorkspaceIdBillingIndexRoute: typeof WorkspacesWorkspaceIdBillingIndexRoute
}

const WorkspacesWorkspaceIdBillingRouteChildren: WorkspacesWorkspaceIdBillingRouteChildren =
  {
    WorkspacesWorkspaceIdBillingAddOnsRoute:
      WorkspacesWorkspaceIdBillingAddOnsRoute,
    WorkspacesWorkspaceIdBillingPlansRoute:
      WorkspacesWorkspaceIdBillingPlansRoute,
    WorkspacesWorkspaceIdBillingSummaryRoute:
      WorkspacesWorkspaceIdBillingSummaryRoute,
    WorkspacesWorkspaceIdBillingIndexRoute:
      WorkspacesWorkspaceIdBillingIndexRoute,
  }

const WorkspacesWorkspaceIdBillingRouteWithChildren =
  WorkspacesWorkspaceIdBillingRoute._addFileChildren(
    WorkspacesWorkspaceIdBillingRouteChildren,
  )

interface WorkspacesWorkspaceIdProfileRouteChildren {
  WorkspacesWorkspaceIdProfileAccountRoute: typeof WorkspacesWorkspaceIdProfileAccountRoute
  WorkspacesWorkspaceIdProfileSettingsRoute: typeof WorkspacesWorkspaceIdProfileSettingsRoute
}

const WorkspacesWorkspaceIdProfileRouteChildren: WorkspacesWorkspaceIdProfileRouteChildren =
  {
    WorkspacesWorkspaceIdProfileAccountRoute:
      WorkspacesWorkspaceIdProfileAccountRoute,
    WorkspacesWorkspaceIdProfileSettingsRoute:
      WorkspacesWorkspaceIdProfileSettingsRoute,
  }

const WorkspacesWorkspaceIdProfileRouteWithChildren =
  WorkspacesWorkspaceIdProfileRoute._addFileChildren(
    WorkspacesWorkspaceIdProfileRouteChildren,
  )

interface WorkspacesWorkspaceIdSettingsRouteChildren {
  WorkspacesWorkspaceIdSettingsSplatRoute: typeof WorkspacesWorkspaceIdSettingsSplatRoute
  WorkspacesWorkspaceIdSettingsAuditsRoute: typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  WorkspacesWorkspaceIdSettingsDetailsRoute: typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  WorkspacesWorkspaceIdSettingsMembersRoute: typeof WorkspacesWorkspaceIdSettingsMembersRoute
  WorkspacesWorkspaceIdSettingsIndexRoute: typeof WorkspacesWorkspaceIdSettingsIndexRoute
}

const WorkspacesWorkspaceIdSettingsRouteChildren: WorkspacesWorkspaceIdSettingsRouteChildren =
  {
    WorkspacesWorkspaceIdSettingsSplatRoute:
      WorkspacesWorkspaceIdSettingsSplatRoute,
    WorkspacesWorkspaceIdSettingsAuditsRoute:
      WorkspacesWorkspaceIdSettingsAuditsRoute,
    WorkspacesWorkspaceIdSettingsDetailsRoute:
      WorkspacesWorkspaceIdSettingsDetailsRoute,
    WorkspacesWorkspaceIdSettingsMembersRoute:
      WorkspacesWorkspaceIdSettingsMembersRoute,
    WorkspacesWorkspaceIdSettingsIndexRoute:
      WorkspacesWorkspaceIdSettingsIndexRoute,
  }

const WorkspacesWorkspaceIdSettingsRouteWithChildren =
  WorkspacesWorkspaceIdSettingsRoute._addFileChildren(
    WorkspacesWorkspaceIdSettingsRouteChildren,
  )

interface WorkspacesWorkspaceIdUsageRouteChildren {
  WorkspacesWorkspaceIdUsageAiSpendRoute: typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  WorkspacesWorkspaceIdUsageMonthlySummaryRoute: typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  WorkspacesWorkspaceIdUsageIndexRoute: typeof WorkspacesWorkspaceIdUsageIndexRoute
}

const WorkspacesWorkspaceIdUsageRouteChildren: WorkspacesWorkspaceIdUsageRouteChildren =
  {
    WorkspacesWorkspaceIdUsageAiSpendRoute:
      WorkspacesWorkspaceIdUsageAiSpendRoute,
    WorkspacesWorkspaceIdUsageMonthlySummaryRoute:
      WorkspacesWorkspaceIdUsageMonthlySummaryRoute,
    WorkspacesWorkspaceIdUsageIndexRoute: WorkspacesWorkspaceIdUsageIndexRoute,
  }

const WorkspacesWorkspaceIdUsageRouteWithChildren =
  WorkspacesWorkspaceIdUsageRoute._addFileChildren(
    WorkspacesWorkspaceIdUsageRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren: WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
}

const WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren: WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren,
  }

const WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdConversationsRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
}

const WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren: WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute,
    WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute,
    WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdSettingsRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute
}

const WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren: WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdWebchatRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdSplatRoute: typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute: typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  WorkspacesWorkspaceIdBotsBotIdConversationsRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  WorkspacesWorkspaceIdBotsBotIdEventsRoute: typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  WorkspacesWorkspaceIdBotsBotIdFilesRoute: typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  WorkspacesWorkspaceIdBotsBotIdHitlRoute: typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  WorkspacesWorkspaceIdBotsBotIdLogsRoute: typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  WorkspacesWorkspaceIdBotsBotIdNewBotRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  WorkspacesWorkspaceIdBotsBotIdNewChatRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  WorkspacesWorkspaceIdBotsBotIdOverviewRoute: typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  WorkspacesWorkspaceIdBotsBotIdSettingsRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren
  WorkspacesWorkspaceIdBotsBotIdUsersRoute: typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren
  WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute: typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  WorkspacesWorkspaceIdBotsBotIdIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
}

const WorkspacesWorkspaceIdBotsBotIdRouteChildren: WorkspacesWorkspaceIdBotsBotIdRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdSplatRoute:
      WorkspacesWorkspaceIdBotsBotIdSplatRoute,
    WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute:
      WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute,
    WorkspacesWorkspaceIdBotsBotIdConversationsRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren,
    WorkspacesWorkspaceIdBotsBotIdEventsRoute:
      WorkspacesWorkspaceIdBotsBotIdEventsRoute,
    WorkspacesWorkspaceIdBotsBotIdFilesRoute:
      WorkspacesWorkspaceIdBotsBotIdFilesRoute,
    WorkspacesWorkspaceIdBotsBotIdHitlRoute:
      WorkspacesWorkspaceIdBotsBotIdHitlRoute,
    WorkspacesWorkspaceIdBotsBotIdLogsRoute:
      WorkspacesWorkspaceIdBotsBotIdLogsRoute,
    WorkspacesWorkspaceIdBotsBotIdNewBotRoute:
      WorkspacesWorkspaceIdBotsBotIdNewBotRoute,
    WorkspacesWorkspaceIdBotsBotIdNewChatRoute:
      WorkspacesWorkspaceIdBotsBotIdNewChatRoute,
    WorkspacesWorkspaceIdBotsBotIdOverviewRoute:
      WorkspacesWorkspaceIdBotsBotIdOverviewRoute,
    WorkspacesWorkspaceIdBotsBotIdSettingsRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren,
    WorkspacesWorkspaceIdBotsBotIdUsersRoute:
      WorkspacesWorkspaceIdBotsBotIdUsersRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren,
    WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute:
      WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute,
    WorkspacesWorkspaceIdBotsBotIdIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute,
    WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute:
      WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute,
    WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute:
      WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute,
    WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute:
      WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute,
    WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdRouteChildren,
  )

interface WorkspacesWorkspaceIdChatbotsBotIdRouteChildren {
  WorkspacesWorkspaceIdChatbotsBotIdSplatRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
}

const WorkspacesWorkspaceIdChatbotsBotIdRouteChildren: WorkspacesWorkspaceIdChatbotsBotIdRouteChildren =
  {
    WorkspacesWorkspaceIdChatbotsBotIdSplatRoute:
      WorkspacesWorkspaceIdChatbotsBotIdSplatRoute,
  }

const WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren =
  WorkspacesWorkspaceIdChatbotsBotIdRoute._addFileChildren(
    WorkspacesWorkspaceIdChatbotsBotIdRouteChildren,
  )

interface WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren {
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
}

const WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren: WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren =
  {
    WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute,
  }

const WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute._addFileChildren(
    WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren,
  )

interface WorkspacesWorkspaceIdRouteChildren {
  WorkspacesWorkspaceIdSplatRoute: typeof WorkspacesWorkspaceIdSplatRoute
  WorkspacesWorkspaceIdBillingRoute: typeof WorkspacesWorkspaceIdBillingRouteWithChildren
  WorkspacesWorkspaceIdBotsRoute: typeof WorkspacesWorkspaceIdBotsRoute
  WorkspacesWorkspaceIdChatbotsRoute: typeof WorkspacesWorkspaceIdChatbotsRoute
  WorkspacesWorkspaceIdCreateBotRoute: typeof WorkspacesWorkspaceIdCreateBotRoute
  WorkspacesWorkspaceIdHomeRoute: typeof WorkspacesWorkspaceIdHomeRoute
  WorkspacesWorkspaceIdProfileRoute: typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  WorkspacesWorkspaceIdSettingsRoute: typeof WorkspacesWorkspaceIdSettingsRouteWithChildren
  WorkspacesWorkspaceIdUsageRoute: typeof WorkspacesWorkspaceIdUsageRouteWithChildren
  WorkspacesWorkspaceIdIndexRoute: typeof WorkspacesWorkspaceIdIndexRoute
  WorkspacesWorkspaceIdBotsBotIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdRouteWithChildren
  WorkspacesWorkspaceIdChatbotsBotIdRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren
  WorkspacesWorkspaceIdIntegrationsIndexRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
}

const WorkspacesWorkspaceIdRouteChildren: WorkspacesWorkspaceIdRouteChildren = {
  WorkspacesWorkspaceIdSplatRoute: WorkspacesWorkspaceIdSplatRoute,
  WorkspacesWorkspaceIdBillingRoute:
    WorkspacesWorkspaceIdBillingRouteWithChildren,
  WorkspacesWorkspaceIdBotsRoute: WorkspacesWorkspaceIdBotsRoute,
  WorkspacesWorkspaceIdChatbotsRoute: WorkspacesWorkspaceIdChatbotsRoute,
  WorkspacesWorkspaceIdCreateBotRoute: WorkspacesWorkspaceIdCreateBotRoute,
  WorkspacesWorkspaceIdHomeRoute: WorkspacesWorkspaceIdHomeRoute,
  WorkspacesWorkspaceIdProfileRoute:
    WorkspacesWorkspaceIdProfileRouteWithChildren,
  WorkspacesWorkspaceIdSettingsRoute:
    WorkspacesWorkspaceIdSettingsRouteWithChildren,
  WorkspacesWorkspaceIdUsageRoute: WorkspacesWorkspaceIdUsageRouteWithChildren,
  WorkspacesWorkspaceIdIndexRoute: WorkspacesWorkspaceIdIndexRoute,
  WorkspacesWorkspaceIdBotsBotIdRoute:
    WorkspacesWorkspaceIdBotsBotIdRouteWithChildren,
  WorkspacesWorkspaceIdChatbotsBotIdRoute:
    WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren,
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute:
    WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren,
  WorkspacesWorkspaceIdIntegrationsIndexRoute:
    WorkspacesWorkspaceIdIntegrationsIndexRoute,
}

const WorkspacesWorkspaceIdRouteWithChildren =
  WorkspacesWorkspaceIdRoute._addFileChildren(
    WorkspacesWorkspaceIdRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/cli-login': typeof CliLoginRoute
  '/forbidden': typeof ForbiddenRoute
  '/welcome': typeof WelcomeRoute
  '/oauth/interstitial': typeof OauthInterstitialRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteWithChildren
  '/workspaces': typeof WorkspacesIndexRoute
  '/workspaces/$workspaceId/$': typeof WorkspacesWorkspaceIdSplatRoute
  '/workspaces/$workspaceId/billing': typeof WorkspacesWorkspaceIdBillingRouteWithChildren
  '/workspaces/$workspaceId/bots': typeof WorkspacesWorkspaceIdBotsRoute
  '/workspaces/$workspaceId/chatbots': typeof WorkspacesWorkspaceIdChatbotsRoute
  '/workspaces/$workspaceId/create-bot': typeof WorkspacesWorkspaceIdCreateBotRoute
  '/workspaces/$workspaceId/home': typeof WorkspacesWorkspaceIdHomeRoute
  '/workspaces/$workspaceId/profile': typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRouteWithChildren
  '/workspaces/$workspaceId/': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/billing/add-ons': typeof WorkspacesWorkspaceIdBillingAddOnsRoute
  '/workspaces/$workspaceId/billing/plans': typeof WorkspacesWorkspaceIdBillingPlansRoute
  '/workspaces/$workspaceId/billing/summary': typeof WorkspacesWorkspaceIdBillingSummaryRoute
  '/workspaces/$workspaceId/bots/$botId': typeof WorkspacesWorkspaceIdBotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/chatbots/$botId': typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/integrations/$integrationId': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren
  '/workspaces/$workspaceId/profile/account': typeof WorkspacesWorkspaceIdProfileAccountRoute
  '/workspaces/$workspaceId/profile/settings': typeof WorkspacesWorkspaceIdProfileSettingsRoute
  '/workspaces/$workspaceId/settings/$': typeof WorkspacesWorkspaceIdSettingsSplatRoute
  '/workspaces/$workspaceId/settings/audits': typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  '/workspaces/$workspaceId/settings/details': typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  '/workspaces/$workspaceId/settings/members': typeof WorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/usage/ai-spend': typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  '/workspaces/$workspaceId/usage/monthly-summary': typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  '/workspaces/$workspaceId/billing/': typeof WorkspacesWorkspaceIdBillingIndexRoute
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/usage/': typeof WorkspacesWorkspaceIdUsageIndexRoute
  '/workspaces/$workspaceId/bots/$botId/$': typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  '/workspaces/$workspaceId/bots/$botId/analytics': typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  '/workspaces/$workspaceId/bots/$botId/conversations': typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/events': typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  '/workspaces/$workspaceId/bots/$botId/files': typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  '/workspaces/$workspaceId/bots/$botId/hitl': typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  '/workspaces/$workspaceId/bots/$botId/logs': typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  '/workspaces/$workspaceId/bots/$botId/new-bot': typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  '/workspaces/$workspaceId/bots/$botId/new-chat': typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  '/workspaces/$workspaceId/bots/$botId/overview': typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  '/workspaces/$workspaceId/bots/$botId/settings': typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/users': typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  '/workspaces/$workspaceId/bots/$botId/webchat': typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/workflows': typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  '/workspaces/$workspaceId/chatbots/$botId/$': typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/$': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/logs': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/settings': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/versions': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  '/workspaces/$workspaceId/bots/$botId/': typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  '/workspaces/$workspaceId/integrations/$integrationId/': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/issues/$issueId': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  '/workspaces/$workspaceId/bots/$botId/settings/access-control': typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  '/workspaces/$workspaceId/bots/$botId/settings/general': typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  '/workspaces/$workspaceId/bots/$botId/tables/$tableId': typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  '/workspaces/$workspaceId/bots/$botId/issues': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/settings/': typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
  '/workspaces/$workspaceId/bots/$botId/tables': typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/': typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/cli-login': typeof CliLoginRoute
  '/forbidden': typeof ForbiddenRoute
  '/welcome': typeof WelcomeRoute
  '/oauth/interstitial': typeof OauthInterstitialRoute
  '/workspaces': typeof WorkspacesIndexRoute
  '/workspaces/$workspaceId/$': typeof WorkspacesWorkspaceIdSplatRoute
  '/workspaces/$workspaceId/bots': typeof WorkspacesWorkspaceIdBotsRoute
  '/workspaces/$workspaceId/chatbots': typeof WorkspacesWorkspaceIdChatbotsRoute
  '/workspaces/$workspaceId/create-bot': typeof WorkspacesWorkspaceIdCreateBotRoute
  '/workspaces/$workspaceId/home': typeof WorkspacesWorkspaceIdHomeRoute
  '/workspaces/$workspaceId/profile': typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/billing/add-ons': typeof WorkspacesWorkspaceIdBillingAddOnsRoute
  '/workspaces/$workspaceId/billing/plans': typeof WorkspacesWorkspaceIdBillingPlansRoute
  '/workspaces/$workspaceId/billing/summary': typeof WorkspacesWorkspaceIdBillingSummaryRoute
  '/workspaces/$workspaceId/chatbots/$botId': typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/profile/account': typeof WorkspacesWorkspaceIdProfileAccountRoute
  '/workspaces/$workspaceId/profile/settings': typeof WorkspacesWorkspaceIdProfileSettingsRoute
  '/workspaces/$workspaceId/settings/$': typeof WorkspacesWorkspaceIdSettingsSplatRoute
  '/workspaces/$workspaceId/settings/audits': typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  '/workspaces/$workspaceId/settings/details': typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  '/workspaces/$workspaceId/settings/members': typeof WorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/usage/ai-spend': typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  '/workspaces/$workspaceId/usage/monthly-summary': typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  '/workspaces/$workspaceId/billing': typeof WorkspacesWorkspaceIdBillingIndexRoute
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageIndexRoute
  '/workspaces/$workspaceId/bots/$botId/$': typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  '/workspaces/$workspaceId/bots/$botId/analytics': typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  '/workspaces/$workspaceId/bots/$botId/conversations': typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/events': typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  '/workspaces/$workspaceId/bots/$botId/files': typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  '/workspaces/$workspaceId/bots/$botId/hitl': typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  '/workspaces/$workspaceId/bots/$botId/logs': typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  '/workspaces/$workspaceId/bots/$botId/new-bot': typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  '/workspaces/$workspaceId/bots/$botId/new-chat': typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  '/workspaces/$workspaceId/bots/$botId/overview': typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  '/workspaces/$workspaceId/bots/$botId/users': typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  '/workspaces/$workspaceId/bots/$botId/workflows': typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  '/workspaces/$workspaceId/chatbots/$botId/$': typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/$': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/logs': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/settings': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/versions': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  '/workspaces/$workspaceId/bots/$botId': typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  '/workspaces/$workspaceId/integrations/$integrationId': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/issues/$issueId': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  '/workspaces/$workspaceId/bots/$botId/settings/access-control': typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  '/workspaces/$workspaceId/bots/$botId/settings/general': typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  '/workspaces/$workspaceId/bots/$botId/tables/$tableId': typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  '/workspaces/$workspaceId/bots/$botId/issues': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/settings': typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
  '/workspaces/$workspaceId/bots/$botId/tables': typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/webchat': typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/cli-login': typeof CliLoginRoute
  '/forbidden': typeof ForbiddenRoute
  '/welcome': typeof WelcomeRoute
  '/oauth/interstitial': typeof OauthInterstitialRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteWithChildren
  '/workspaces/': typeof WorkspacesIndexRoute
  '/workspaces/$workspaceId/$': typeof WorkspacesWorkspaceIdSplatRoute
  '/workspaces/$workspaceId/billing': typeof WorkspacesWorkspaceIdBillingRouteWithChildren
  '/workspaces/$workspaceId/bots_': typeof WorkspacesWorkspaceIdBotsRoute
  '/workspaces/$workspaceId/chatbots_': typeof WorkspacesWorkspaceIdChatbotsRoute
  '/workspaces/$workspaceId/create-bot': typeof WorkspacesWorkspaceIdCreateBotRoute
  '/workspaces/$workspaceId/home': typeof WorkspacesWorkspaceIdHomeRoute
  '/workspaces/$workspaceId/profile': typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRouteWithChildren
  '/workspaces/$workspaceId/': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/billing/add-ons': typeof WorkspacesWorkspaceIdBillingAddOnsRoute
  '/workspaces/$workspaceId/billing/plans': typeof WorkspacesWorkspaceIdBillingPlansRoute
  '/workspaces/$workspaceId/billing/summary': typeof WorkspacesWorkspaceIdBillingSummaryRoute
  '/workspaces/$workspaceId/bots/$botId': typeof WorkspacesWorkspaceIdBotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/chatbots/$botId': typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/integrations/$integrationId': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren
  '/workspaces/$workspaceId/profile/account': typeof WorkspacesWorkspaceIdProfileAccountRoute
  '/workspaces/$workspaceId/profile/settings': typeof WorkspacesWorkspaceIdProfileSettingsRoute
  '/workspaces/$workspaceId/settings/$': typeof WorkspacesWorkspaceIdSettingsSplatRoute
  '/workspaces/$workspaceId/settings/audits': typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  '/workspaces/$workspaceId/settings/details': typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  '/workspaces/$workspaceId/settings/members': typeof WorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/usage/ai-spend': typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  '/workspaces/$workspaceId/usage/monthly-summary': typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  '/workspaces/$workspaceId/billing/': typeof WorkspacesWorkspaceIdBillingIndexRoute
  '/workspaces/$workspaceId/integrations/': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/usage/': typeof WorkspacesWorkspaceIdUsageIndexRoute
  '/workspaces/$workspaceId/bots/$botId/$': typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  '/workspaces/$workspaceId/bots/$botId/analytics': typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  '/workspaces/$workspaceId/bots/$botId/conversations': typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/events': typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  '/workspaces/$workspaceId/bots/$botId/files': typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  '/workspaces/$workspaceId/bots/$botId/hitl': typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  '/workspaces/$workspaceId/bots/$botId/logs': typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  '/workspaces/$workspaceId/bots/$botId/new-bot': typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  '/workspaces/$workspaceId/bots/$botId/new-chat': typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  '/workspaces/$workspaceId/bots/$botId/overview': typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  '/workspaces/$workspaceId/bots/$botId/settings': typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/users': typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  '/workspaces/$workspaceId/bots/$botId/webchat': typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/workflows': typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  '/workspaces/$workspaceId/chatbots/$botId/$': typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/$': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/logs': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/settings': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/versions': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  '/workspaces/$workspaceId/bots/$botId/': typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  '/workspaces/$workspaceId/integrations/$integrationId/': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/issues/$issueId': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  '/workspaces/$workspaceId/bots/$botId/settings/access-control': typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  '/workspaces/$workspaceId/bots/$botId/settings/general': typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  '/workspaces/$workspaceId/bots/$botId/tables/$tableId': typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  '/workspaces/$workspaceId/bots/$botId/issues/': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/settings/': typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
  '/workspaces/$workspaceId/bots/$botId/tables/': typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/': typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ThemeRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/cli-login'
    | '/forbidden'
    | '/welcome'
    | '/oauth/interstitial'
    | '/workspaces/$workspaceId'
    | '/workspaces'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/billing'
    | '/workspaces/$workspaceId/bots'
    | '/workspaces/$workspaceId/chatbots'
    | '/workspaces/$workspaceId/create-bot'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/profile'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/billing/add-ons'
    | '/workspaces/$workspaceId/billing/plans'
    | '/workspaces/$workspaceId/billing/summary'
    | '/workspaces/$workspaceId/bots/$botId'
    | '/workspaces/$workspaceId/chatbots/$botId'
    | '/workspaces/$workspaceId/integrations/$integrationId'
    | '/workspaces/$workspaceId/profile/account'
    | '/workspaces/$workspaceId/profile/settings'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/audits'
    | '/workspaces/$workspaceId/settings/details'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/usage/ai-spend'
    | '/workspaces/$workspaceId/usage/monthly-summary'
    | '/workspaces/$workspaceId/billing/'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/usage/'
    | '/workspaces/$workspaceId/bots/$botId/$'
    | '/workspaces/$workspaceId/bots/$botId/analytics'
    | '/workspaces/$workspaceId/bots/$botId/conversations'
    | '/workspaces/$workspaceId/bots/$botId/events'
    | '/workspaces/$workspaceId/bots/$botId/files'
    | '/workspaces/$workspaceId/bots/$botId/hitl'
    | '/workspaces/$workspaceId/bots/$botId/logs'
    | '/workspaces/$workspaceId/bots/$botId/new-bot'
    | '/workspaces/$workspaceId/bots/$botId/new-chat'
    | '/workspaces/$workspaceId/bots/$botId/overview'
    | '/workspaces/$workspaceId/bots/$botId/settings'
    | '/workspaces/$workspaceId/bots/$botId/users'
    | '/workspaces/$workspaceId/bots/$botId/webchat'
    | '/workspaces/$workspaceId/bots/$botId/workflows'
    | '/workspaces/$workspaceId/chatbots/$botId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/logs'
    | '/workspaces/$workspaceId/integrations/$integrationId/settings'
    | '/workspaces/$workspaceId/integrations/$integrationId/versions'
    | '/workspaces/$workspaceId/bots/$botId/'
    | '/workspaces/$workspaceId/integrations/$integrationId/'
    | '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
    | '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
    | '/workspaces/$workspaceId/bots/$botId/settings/access-control'
    | '/workspaces/$workspaceId/bots/$botId/settings/general'
    | '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
    | '/workspaces/$workspaceId/bots/$botId/issues'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases'
    | '/workspaces/$workspaceId/bots/$botId/settings/'
    | '/workspaces/$workspaceId/bots/$botId/tables'
    | '/workspaces/$workspaceId/bots/$botId/webchat/'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/cli-login'
    | '/forbidden'
    | '/welcome'
    | '/oauth/interstitial'
    | '/workspaces'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/bots'
    | '/workspaces/$workspaceId/chatbots'
    | '/workspaces/$workspaceId/create-bot'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/profile'
    | '/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/billing/add-ons'
    | '/workspaces/$workspaceId/billing/plans'
    | '/workspaces/$workspaceId/billing/summary'
    | '/workspaces/$workspaceId/chatbots/$botId'
    | '/workspaces/$workspaceId/profile/account'
    | '/workspaces/$workspaceId/profile/settings'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/audits'
    | '/workspaces/$workspaceId/settings/details'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/usage/ai-spend'
    | '/workspaces/$workspaceId/usage/monthly-summary'
    | '/workspaces/$workspaceId/billing'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/bots/$botId/$'
    | '/workspaces/$workspaceId/bots/$botId/analytics'
    | '/workspaces/$workspaceId/bots/$botId/conversations'
    | '/workspaces/$workspaceId/bots/$botId/events'
    | '/workspaces/$workspaceId/bots/$botId/files'
    | '/workspaces/$workspaceId/bots/$botId/hitl'
    | '/workspaces/$workspaceId/bots/$botId/logs'
    | '/workspaces/$workspaceId/bots/$botId/new-bot'
    | '/workspaces/$workspaceId/bots/$botId/new-chat'
    | '/workspaces/$workspaceId/bots/$botId/overview'
    | '/workspaces/$workspaceId/bots/$botId/users'
    | '/workspaces/$workspaceId/bots/$botId/workflows'
    | '/workspaces/$workspaceId/chatbots/$botId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/logs'
    | '/workspaces/$workspaceId/integrations/$integrationId/settings'
    | '/workspaces/$workspaceId/integrations/$integrationId/versions'
    | '/workspaces/$workspaceId/bots/$botId'
    | '/workspaces/$workspaceId/integrations/$integrationId'
    | '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
    | '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
    | '/workspaces/$workspaceId/bots/$botId/settings/access-control'
    | '/workspaces/$workspaceId/bots/$botId/settings/general'
    | '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
    | '/workspaces/$workspaceId/bots/$botId/issues'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases'
    | '/workspaces/$workspaceId/bots/$botId/settings'
    | '/workspaces/$workspaceId/bots/$botId/tables'
    | '/workspaces/$workspaceId/bots/$botId/webchat'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/cli-login'
    | '/forbidden'
    | '/welcome'
    | '/oauth/interstitial'
    | '/workspaces/$workspaceId'
    | '/workspaces/'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/billing'
    | '/workspaces/$workspaceId/bots_'
    | '/workspaces/$workspaceId/chatbots_'
    | '/workspaces/$workspaceId/create-bot'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/profile'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/billing/add-ons'
    | '/workspaces/$workspaceId/billing/plans'
    | '/workspaces/$workspaceId/billing/summary'
    | '/workspaces/$workspaceId/bots/$botId'
    | '/workspaces/$workspaceId/chatbots/$botId'
    | '/workspaces/$workspaceId/integrations/$integrationId'
    | '/workspaces/$workspaceId/profile/account'
    | '/workspaces/$workspaceId/profile/settings'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/audits'
    | '/workspaces/$workspaceId/settings/details'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/usage/ai-spend'
    | '/workspaces/$workspaceId/usage/monthly-summary'
    | '/workspaces/$workspaceId/billing/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/usage/'
    | '/workspaces/$workspaceId/bots/$botId/$'
    | '/workspaces/$workspaceId/bots/$botId/analytics'
    | '/workspaces/$workspaceId/bots/$botId/conversations'
    | '/workspaces/$workspaceId/bots/$botId/events'
    | '/workspaces/$workspaceId/bots/$botId/files'
    | '/workspaces/$workspaceId/bots/$botId/hitl'
    | '/workspaces/$workspaceId/bots/$botId/logs'
    | '/workspaces/$workspaceId/bots/$botId/new-bot'
    | '/workspaces/$workspaceId/bots/$botId/new-chat'
    | '/workspaces/$workspaceId/bots/$botId/overview'
    | '/workspaces/$workspaceId/bots/$botId/settings'
    | '/workspaces/$workspaceId/bots/$botId/users'
    | '/workspaces/$workspaceId/bots/$botId/webchat'
    | '/workspaces/$workspaceId/bots/$botId/workflows'
    | '/workspaces/$workspaceId/chatbots/$botId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/logs'
    | '/workspaces/$workspaceId/integrations/$integrationId/settings'
    | '/workspaces/$workspaceId/integrations/$integrationId/versions'
    | '/workspaces/$workspaceId/bots/$botId/'
    | '/workspaces/$workspaceId/integrations/$integrationId/'
    | '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
    | '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
    | '/workspaces/$workspaceId/bots/$botId/settings/access-control'
    | '/workspaces/$workspaceId/bots/$botId/settings/general'
    | '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
    | '/workspaces/$workspaceId/bots/$botId/issues/'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/'
    | '/workspaces/$workspaceId/bots/$botId/settings/'
    | '/workspaces/$workspaceId/bots/$botId/tables/'
    | '/workspaces/$workspaceId/bots/$botId/webchat/'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/theme'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  CliLoginRoute: typeof CliLoginRoute
  ForbiddenRoute: typeof ForbiddenRoute
  WelcomeRoute: typeof WelcomeRoute
  OauthInterstitialRoute: typeof OauthInterstitialRoute
  WorkspacesWorkspaceIdRoute: typeof WorkspacesWorkspaceIdRouteWithChildren
  WorkspacesIndexRoute: typeof WorkspacesIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  CliLoginRoute: CliLoginRoute,
  ForbiddenRoute: ForbiddenRoute,
  WelcomeRoute: WelcomeRoute,
  OauthInterstitialRoute: OauthInterstitialRoute,
  WorkspacesWorkspaceIdRoute: WorkspacesWorkspaceIdRouteWithChildren,
  WorkspacesIndexRoute: WorkspacesIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/$",
        "/cli-login",
        "/forbidden",
        "/welcome",
        "/oauth/interstitial",
        "/workspaces/$workspaceId",
        "/workspaces/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/$": {
      "filePath": "$.tsx"
    },
    "/cli-login": {
      "filePath": "cli-login.tsx"
    },
    "/forbidden": {
      "filePath": "forbidden.tsx"
    },
    "/welcome": {
      "filePath": "welcome.tsx"
    },
    "/oauth/interstitial": {
      "filePath": "oauth/interstitial.tsx"
    },
    "/workspaces/$workspaceId": {
      "filePath": "workspaces/$workspaceId.tsx",
      "children": [
        "/workspaces/$workspaceId/$",
        "/workspaces/$workspaceId/billing",
        "/workspaces/$workspaceId/bots_",
        "/workspaces/$workspaceId/chatbots_",
        "/workspaces/$workspaceId/create-bot",
        "/workspaces/$workspaceId/home",
        "/workspaces/$workspaceId/profile",
        "/workspaces/$workspaceId/settings",
        "/workspaces/$workspaceId/usage",
        "/workspaces/$workspaceId/",
        "/workspaces/$workspaceId/bots/$botId",
        "/workspaces/$workspaceId/chatbots/$botId",
        "/workspaces/$workspaceId/integrations/$integrationId",
        "/workspaces/$workspaceId/integrations/"
      ]
    },
    "/workspaces/": {
      "filePath": "workspaces/index.tsx"
    },
    "/workspaces/$workspaceId/$": {
      "filePath": "workspaces/$workspaceId/$.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/billing": {
      "filePath": "workspaces/$workspaceId/billing.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/billing/add-ons",
        "/workspaces/$workspaceId/billing/plans",
        "/workspaces/$workspaceId/billing/summary",
        "/workspaces/$workspaceId/billing/"
      ]
    },
    "/workspaces/$workspaceId/bots_": {
      "filePath": "workspaces/$workspaceId/bots_.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/chatbots_": {
      "filePath": "workspaces/$workspaceId/chatbots_.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/create-bot": {
      "filePath": "workspaces/$workspaceId/create-bot.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/home": {
      "filePath": "workspaces/$workspaceId/home.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/profile": {
      "filePath": "workspaces/$workspaceId/profile.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/profile/account",
        "/workspaces/$workspaceId/profile/settings"
      ]
    },
    "/workspaces/$workspaceId/settings": {
      "filePath": "workspaces/$workspaceId/settings.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/settings/$",
        "/workspaces/$workspaceId/settings/audits",
        "/workspaces/$workspaceId/settings/details",
        "/workspaces/$workspaceId/settings/members",
        "/workspaces/$workspaceId/settings/"
      ]
    },
    "/workspaces/$workspaceId/usage": {
      "filePath": "workspaces/$workspaceId/usage.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/usage/ai-spend",
        "/workspaces/$workspaceId/usage/monthly-summary",
        "/workspaces/$workspaceId/usage/"
      ]
    },
    "/workspaces/$workspaceId/": {
      "filePath": "workspaces/$workspaceId/index.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/billing/add-ons": {
      "filePath": "workspaces/$workspaceId/billing/add-ons.tsx",
      "parent": "/workspaces/$workspaceId/billing"
    },
    "/workspaces/$workspaceId/billing/plans": {
      "filePath": "workspaces/$workspaceId/billing/plans.tsx",
      "parent": "/workspaces/$workspaceId/billing"
    },
    "/workspaces/$workspaceId/billing/summary": {
      "filePath": "workspaces/$workspaceId/billing/summary.tsx",
      "parent": "/workspaces/$workspaceId/billing"
    },
    "/workspaces/$workspaceId/bots/$botId": {
      "filePath": "workspaces/$workspaceId/bots/$botId.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/bots/$botId/$",
        "/workspaces/$workspaceId/bots/$botId/analytics",
        "/workspaces/$workspaceId/bots/$botId/conversations",
        "/workspaces/$workspaceId/bots/$botId/events",
        "/workspaces/$workspaceId/bots/$botId/files",
        "/workspaces/$workspaceId/bots/$botId/hitl",
        "/workspaces/$workspaceId/bots/$botId/logs",
        "/workspaces/$workspaceId/bots/$botId/new-bot",
        "/workspaces/$workspaceId/bots/$botId/new-chat",
        "/workspaces/$workspaceId/bots/$botId/overview",
        "/workspaces/$workspaceId/bots/$botId/settings",
        "/workspaces/$workspaceId/bots/$botId/users",
        "/workspaces/$workspaceId/bots/$botId/webchat",
        "/workspaces/$workspaceId/bots/$botId/workflows",
        "/workspaces/$workspaceId/bots/$botId/",
        "/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId",
        "/workspaces/$workspaceId/bots/$botId/issues/$issueId",
        "/workspaces/$workspaceId/bots/$botId/tables/$tableId",
        "/workspaces/$workspaceId/bots/$botId/issues/",
        "/workspaces/$workspaceId/bots/$botId/knowledge-bases/",
        "/workspaces/$workspaceId/bots/$botId/tables/",
        "/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId",
        "/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/"
      ]
    },
    "/workspaces/$workspaceId/chatbots/$botId": {
      "filePath": "workspaces/$workspaceId/chatbots/$botId.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/chatbots/$botId/$"
      ]
    },
    "/workspaces/$workspaceId/integrations/$integrationId": {
      "filePath": "workspaces/$workspaceId/integrations/$integrationId.tsx",
      "parent": "/workspaces/$workspaceId",
      "children": [
        "/workspaces/$workspaceId/integrations/$integrationId/$",
        "/workspaces/$workspaceId/integrations/$integrationId/logs",
        "/workspaces/$workspaceId/integrations/$integrationId/settings",
        "/workspaces/$workspaceId/integrations/$integrationId/versions",
        "/workspaces/$workspaceId/integrations/$integrationId/"
      ]
    },
    "/workspaces/$workspaceId/profile/account": {
      "filePath": "workspaces/$workspaceId/profile/account.tsx",
      "parent": "/workspaces/$workspaceId/profile"
    },
    "/workspaces/$workspaceId/profile/settings": {
      "filePath": "workspaces/$workspaceId/profile/settings.tsx",
      "parent": "/workspaces/$workspaceId/profile"
    },
    "/workspaces/$workspaceId/settings/$": {
      "filePath": "workspaces/$workspaceId/settings/$.tsx",
      "parent": "/workspaces/$workspaceId/settings"
    },
    "/workspaces/$workspaceId/settings/audits": {
      "filePath": "workspaces/$workspaceId/settings/audits.tsx",
      "parent": "/workspaces/$workspaceId/settings"
    },
    "/workspaces/$workspaceId/settings/details": {
      "filePath": "workspaces/$workspaceId/settings/details.tsx",
      "parent": "/workspaces/$workspaceId/settings"
    },
    "/workspaces/$workspaceId/settings/members": {
      "filePath": "workspaces/$workspaceId/settings/members.tsx",
      "parent": "/workspaces/$workspaceId/settings"
    },
    "/workspaces/$workspaceId/usage/ai-spend": {
      "filePath": "workspaces/$workspaceId/usage/ai-spend.tsx",
      "parent": "/workspaces/$workspaceId/usage"
    },
    "/workspaces/$workspaceId/usage/monthly-summary": {
      "filePath": "workspaces/$workspaceId/usage/monthly-summary.tsx",
      "parent": "/workspaces/$workspaceId/usage"
    },
    "/workspaces/$workspaceId/billing/": {
      "filePath": "workspaces/$workspaceId/billing/index.tsx",
      "parent": "/workspaces/$workspaceId/billing"
    },
    "/workspaces/$workspaceId/integrations/": {
      "filePath": "workspaces/$workspaceId/integrations/index.tsx",
      "parent": "/workspaces/$workspaceId"
    },
    "/workspaces/$workspaceId/settings/": {
      "filePath": "workspaces/$workspaceId/settings/index.tsx",
      "parent": "/workspaces/$workspaceId/settings"
    },
    "/workspaces/$workspaceId/usage/": {
      "filePath": "workspaces/$workspaceId/usage/index.tsx",
      "parent": "/workspaces/$workspaceId/usage"
    },
    "/workspaces/$workspaceId/bots/$botId/$": {
      "filePath": "workspaces/$workspaceId/bots/$botId/$.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/analytics": {
      "filePath": "workspaces/$workspaceId/bots/$botId/analytics.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/conversations": {
      "filePath": "workspaces/$workspaceId/bots/$botId/conversations.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId",
      "children": [
        "/workspaces/$workspaceId/bots/$botId/conversations/$conversationId"
      ]
    },
    "/workspaces/$workspaceId/bots/$botId/events": {
      "filePath": "workspaces/$workspaceId/bots/$botId/events.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/files": {
      "filePath": "workspaces/$workspaceId/bots/$botId/files.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/hitl": {
      "filePath": "workspaces/$workspaceId/bots/$botId/hitl.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/logs": {
      "filePath": "workspaces/$workspaceId/bots/$botId/logs.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/new-bot": {
      "filePath": "workspaces/$workspaceId/bots/$botId/new-bot.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/new-chat": {
      "filePath": "workspaces/$workspaceId/bots/$botId/new-chat.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/overview": {
      "filePath": "workspaces/$workspaceId/bots/$botId/overview.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/settings": {
      "filePath": "workspaces/$workspaceId/bots/$botId/settings.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId",
      "children": [
        "/workspaces/$workspaceId/bots/$botId/settings/access-control",
        "/workspaces/$workspaceId/bots/$botId/settings/general",
        "/workspaces/$workspaceId/bots/$botId/settings/"
      ]
    },
    "/workspaces/$workspaceId/bots/$botId/users": {
      "filePath": "workspaces/$workspaceId/bots/$botId/users.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/webchat": {
      "filePath": "workspaces/$workspaceId/bots/$botId/webchat.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId",
      "children": [
        "/workspaces/$workspaceId/bots/$botId/webchat/",
        "/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings",
        "/workspaces/$workspaceId/bots/$botId/webchat/v2/general",
        "/workspaces/$workspaceId/bots/$botId/webchat/v2/share",
        "/workspaces/$workspaceId/bots/$botId/webchat/v2/theme"
      ]
    },
    "/workspaces/$workspaceId/bots/$botId/workflows": {
      "filePath": "workspaces/$workspaceId/bots/$botId/workflows.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/chatbots/$botId/$": {
      "filePath": "workspaces/$workspaceId/chatbots/$botId/$.tsx",
      "parent": "/workspaces/$workspaceId/chatbots/$botId"
    },
    "/workspaces/$workspaceId/integrations/$integrationId/$": {
      "filePath": "workspaces/$workspaceId/integrations/$integrationId/$.tsx",
      "parent": "/workspaces/$workspaceId/integrations/$integrationId"
    },
    "/workspaces/$workspaceId/integrations/$integrationId/logs": {
      "filePath": "workspaces/$workspaceId/integrations/$integrationId/logs.tsx",
      "parent": "/workspaces/$workspaceId/integrations/$integrationId"
    },
    "/workspaces/$workspaceId/integrations/$integrationId/settings": {
      "filePath": "workspaces/$workspaceId/integrations/$integrationId/settings.tsx",
      "parent": "/workspaces/$workspaceId/integrations/$integrationId"
    },
    "/workspaces/$workspaceId/integrations/$integrationId/versions": {
      "filePath": "workspaces/$workspaceId/integrations/$integrationId/versions.tsx",
      "parent": "/workspaces/$workspaceId/integrations/$integrationId"
    },
    "/workspaces/$workspaceId/bots/$botId/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/integrations/$integrationId/": {
      "filePath": "workspaces/$workspaceId/integrations/$integrationId/index.tsx",
      "parent": "/workspaces/$workspaceId/integrations/$integrationId"
    },
    "/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId": {
      "filePath": "workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/conversations/$conversationId": {
      "filePath": "workspaces/$workspaceId/bots/$botId/conversations/$conversationId.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/conversations",
      "children": [
        "/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId"
      ]
    },
    "/workspaces/$workspaceId/bots/$botId/issues/$issueId": {
      "filePath": "workspaces/$workspaceId/bots/$botId/issues/$issueId.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/settings/access-control": {
      "filePath": "workspaces/$workspaceId/bots/$botId/settings/access-control.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/settings"
    },
    "/workspaces/$workspaceId/bots/$botId/settings/general": {
      "filePath": "workspaces/$workspaceId/bots/$botId/settings/general.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/settings"
    },
    "/workspaces/$workspaceId/bots/$botId/tables/$tableId": {
      "filePath": "workspaces/$workspaceId/bots/$botId/tables/$tableId.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/issues/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/issues/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/knowledge-bases/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/knowledge-bases/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/settings/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/settings/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/settings"
    },
    "/workspaces/$workspaceId/bots/$botId/tables/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/tables/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/webchat/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/webchat/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/webchat"
    },
    "/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId": {
      "filePath": "workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings": {
      "filePath": "workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/webchat"
    },
    "/workspaces/$workspaceId/bots/$botId/webchat/v2/general": {
      "filePath": "workspaces/$workspaceId/bots/$botId/webchat/v2/general.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/webchat"
    },
    "/workspaces/$workspaceId/bots/$botId/webchat/v2/share": {
      "filePath": "workspaces/$workspaceId/bots/$botId/webchat/v2/share.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/webchat"
    },
    "/workspaces/$workspaceId/bots/$botId/webchat/v2/theme": {
      "filePath": "workspaces/$workspaceId/bots/$botId/webchat/v2/theme.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/webchat"
    },
    "/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/": {
      "filePath": "workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/index.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId"
    },
    "/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId": {
      "filePath": "workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId.tsx",
      "parent": "/workspaces/$workspaceId/bots/$botId/conversations/$conversationId"
    }
  }
}
ROUTE_MANIFEST_END */
